// extracted by mini-css-extract-plugin
module.exports = {"btn_confirm":"ReminderPopup_btn_confirm__AgkdA","btn_delete":"ReminderPopup_btn_delete__1n5uj"};